// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d6754cf0","732":"dd0f2c3b"}[chunkId] + ".chunk.js";
};